import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b30e560a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b30e560a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30e560a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b30e560a')) {
      api.createRecord('b30e560a', component.options)
    } else {
      api.reload('b30e560a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b30e560a&scoped=true&", function () {
      api.rerender('b30e560a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25dR36CZQ4gZE/JS/comp/SearchFilterTokens.vue"
export default component.exports